import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {initialSystemStatusState} from "../state/SystemStatusState";
import {SystemStatusViewType} from "../locations/SystemStatusLocation";
import {SystemStatusResponseDto} from "../services/system/SystemStatusResponseDto";
import {DateTime} from "luxon";

export const systemStatusSlice = createSlice({
    name: "systemStatus",
    initialState: initialSystemStatusState,
    reducers: {
        setView(state, {payload}: PayloadAction<SystemStatusViewType>) {
            state.view = payload;
        },
        updateSystemStatus(state, {payload}: PayloadAction<SystemStatusResponseDto>) {
            for (const s of payload.Services) {
                // noinspection SuspiciousTypeOfGuard
                if (s.LastSeen && (typeof s.LastSeen === "string")) {
                    s.LastSeen = DateTime.fromISO(s.LastSeen);
                }
            }
            state.lastUpdateTime= DateTime.local();
            state.status = payload;
        },
    },
});

export namespace SystemStatusActions {
    export const {
        setView,
        updateSystemStatus,
    } = systemStatusSlice.actions;
}
